import { createContext, useContext, useEffect, useState } from 'react';
import { fetchSiteSettings } from '../lib/sanity';

const SiteSettingsContext = createContext({
  shareThumbnail: null,
  siteIcon: null,
  loading: true,
});

export function SiteSettingsProvider({ children }) {
  const [shareThumbnail, setShareThumbnail] = useState(null);
  const [siteIcon, setSiteIcon] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSiteSettings()
      .then((settings) => {
        setShareThumbnail(settings?.shareThumbnail || null);
        setSiteIcon(settings?.siteIcon || settings?.shareThumbnail || null);
      })
      .catch((error) => {
        console.error('Failed to fetch site settings:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ shareThumbnail, siteIcon, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
